import { render, staticRenderFns } from "./QuestionDocumentsComponent.vue?vue&type=template&id=c88c7c9c&"
import script from "./QuestionDocumentsComponent.vue?vue&type=script&lang=js&"
export * from "./QuestionDocumentsComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports